import { CardContent } from "@/components/ui/card";
import CountryPopup from "./CountryPopup";
import StatePopup from "./StatePopup";
import CountryCodePopup from "@/components/CustomUI/modals/CountryCodePopup";
import ErrorLabel from "./ErrorLabel";
import { Button } from "@/components/ui/button";
import { Line } from "@/components/CustomUI/modules/Loaders";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const AddAddress = ({
    formData,
    addressFormat,
    errorMsg,
    countryCodeDropdown,
    loading,
    handleChangeCountry,
    pincodeChange,
    pincodeFocus,
    handleChangeFormData,
    handleChangeCountryCode,
    toggleCountryCode,
    phoneNumberChange,
    phoneNumberFocus,
    onSubmitForm,
}) => {

    return (
        <>
            <CardContent className="px-0 py-0 mt-3">
                <CountryPopup
                    currentCountry={formData.country}
                    handleChangeCountry={handleChangeCountry}
                />

                <input
                    className={`
                        ${errorMsg?.first_name ? "border-[red]" : "border-slate-300"}
                        p-2 border mt-5 text-font-primary h-[45px] w-full 
                        hover:outline-none rounded-none focus:outline-none
                        placeholder:text-slate-400 placeholder:text-sm 
                        placeholder:tracking-wide 
                    `}
                    placeholder="Full Name"
                    type="text"
                    name="name"
                    value={formData.full_name}
                    onChange={(e) => handleChangeFormData('full_name', e.target.value)}
                />
                <ErrorLabel error={errorMsg?.first_name} />

                <input
                    className={`
                        ${errorMsg?.street_address_1 ? "border-[red]" : "border-slate-300"}
                        p-2 border text-font-primary h-[45px] w-full 
                        hover:outline-none rounded-none focus:outline-none
                        placeholder:text-slate-400 placeholder:text-sm 
                        placeholder:tracking-wide 
                    `}
                    placeholder="Address"
                    type="text"
                    name="address"
                    value={formData.street_address}
                    onChange={(e) => handleChangeFormData('street_address', e.target.value)}
                />
                <ErrorLabel error={errorMsg?.street_address_1} />

                <div className="flex gap-x-3 items-start">
                    {
                        addressFormat.city && !addressFormat.city.is_hidden &&
                        <div className="w-full">
                            <input
                                className={`
                                    ${errorMsg?.city ? "border-[red]" : "border-slate-300"}
                                    p-2 border text-font-primary h-[45px] w-full 
                                    hover:outline-none rounded-none focus:outline-none
                                    placeholder:text-slate-400 placeholder:text-sm 
                                    placeholder:tracking-wide 
                                `}
                                placeholder={addressFormat.city.label}
                                type="text"
                                value={formData.city}
                                name="city"
                                onChange={(e) => handleChangeFormData('city', e.target.value)}
                            />
                            <ErrorLabel error={errorMsg?.city} />
                        </div>
                    }

                    {
                        addressFormat.city_area && !addressFormat.city_area.is_hidden &&
                        <div className="w-full">
                            <input
                                className={`
                                    ${errorMsg?.city_area ? "border-[red]" : "border-slate-300"}
                                    p-2 border text-font-primary h-[45px] w-full 
                                    hover:outline-none rounded-none focus:outline-none
                                    placeholder:text-slate-400 placeholder:text-xs 
                                    placeholder:tracking-wide 
                                `}
                                placeholder={addressFormat.city_area.label}
                                type="text"
                                value={formData.city_area}
                                name="city"
                                onChange={(e) => handleChangeFormData('city_area', e.target.value)}
                            />
                            <ErrorLabel error={errorMsg?.city_area} />
                        </div>
                    }

                    {
                        addressFormat.country_area && !addressFormat.country_area.is_hidden &&
                        <div className="w-full">
                            <StatePopup
                                currentState={formData.country_area}
                                label={addressFormat.country_area.label}
                                stateChoices={addressFormat.country_area?.choices}
                                handleChangeState={handleChangeFormData}
                                error={errorMsg?.country_area}
                            />
                            <ErrorLabel error={errorMsg?.country_area} />
                        </div>
                    }

                    <div className="w-full">
                        <input
                            className={`
                                ${errorMsg?.postal_code ? "border-[red]" : "border-slate-300"}
                                p-2 border text-font-primary h-[45px] w-full 
                                hover:outline-none rounded-none focus:outline-none
                                placeholder:text-slate-400 placeholder:text-sm 
                                placeholder:tracking-wide 
                            `}
                            placeholder="Postal Code"
                            type="text"
                            value={formData.pin_code}
                            name="changeZip"
                            onChange={(e) => handleChangeFormData('pin_code', e.target.value)}
                            onBlur={pincodeChange}
                            onFocus={pincodeFocus}
                        />
                        <ErrorLabel error={errorMsg?.postal_code} />
                    </div>
                </div>

                <div className="flex">
                    <CountryCodePopup
                        selected={formData.phone_0}
                        titleHidden={true}
                        columns={1}
                        popupVisible={countryCodeDropdown}
                        extraClasses="rounded-none h-[45px] border border-slate-300 border-r-0"
                        onChange={handleChangeCountryCode}
                        handlePopupVisible={toggleCountryCode}
                    />

                    <div className="w-full relative">
                        <input
                            className={`
                                ${errorMsg?.phone ? "border-[red]" : "border-slate-300"}
                                p-2 border text-font-primary h-[45px] w-full 
                                hover:outline-none rounded-none focus:outline-none
                                placeholder:text-slate-400 placeholder:text-sm 
                                placeholder:tracking-wide 
                            `}
                            placeholder="Phone"
                            type="tel"
                            value={formData.phone_1}
                            // name="phone"
                            onChange={(e) => handleChangeFormData('phone_1', e.target.value)}
                            onBlur={() => phoneNumberChange(formData.phone_0)}
                            onFocus={phoneNumberFocus}
                        />
                        <TooltipProvider
                            delayDuration={100}
                        >
                            <Tooltip>
                                <TooltipTrigger className="w-[40px] absolute right-0 top-[15px]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        fill="#919191"
                                        version="1.1"
                                        width={15}
                                        height={15}
                                        viewBox="0 0 93.936 93.936"
                                        xmlSpace="preserve"
                                        className="drop-shadow-sm"
                                        role="button"
                                    >
                                        <g>
                                            <path d="M80.179,13.758c-18.342-18.342-48.08-18.342-66.422,0c-18.342,18.341-18.342,48.08,0,66.421   c18.342,18.342,48.08,18.342,66.422,0C98.521,61.837,98.521,32.099,80.179,13.758z M44.144,83.117   c-4.057,0-7.001-3.071-7.001-7.305c0-4.291,2.987-7.404,7.102-7.404c4.123,0,7.001,3.044,7.001,7.404   C51.246,80.113,48.326,83.117,44.144,83.117z M54.73,44.921c-4.15,4.905-5.796,9.117-5.503,14.088l0.097,2.495   c0.011,0.062,0.017,0.125,0.017,0.188c0,0.58-0.47,1.051-1.05,1.051c-0.004-0.001-0.008-0.001-0.012,0h-7.867   c-0.549,0-1.005-0.423-1.047-0.97l-0.202-2.623c-0.676-6.082,1.508-12.218,6.494-18.202c4.319-5.087,6.816-8.865,6.816-13.145   c0-4.829-3.036-7.536-8.548-7.624c-3.403,0-7.242,1.171-9.534,2.913c-0.264,0.201-0.607,0.264-0.925,0.173   s-0.575-0.327-0.693-0.636l-2.42-6.354c-0.169-0.442-0.02-0.943,0.364-1.224c3.538-2.573,9.441-4.235,15.041-4.235   c12.36,0,17.894,7.975,17.894,15.877C63.652,33.765,59.785,38.919,54.73,44.921z" />
                                        </g>
                                    </svg>
                                </TooltipTrigger>
                                <TooltipContent className="rounded bg-black drop-shadow-sm max-w-[200px]">
                                    <p className="text-[10px] text-white text-center">
                                        In case we need to contact you about your order.
                                    </p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                        <ErrorLabel error={errorMsg?.phone} />
                    </div>
                </div>

            </CardContent>

            <div className="mt-3 w-full flex justify-end">
                <Button
                    variant="primary"
                    className="
                        bg-[#45d4d5] rounded-sm
                        px-12 py-0 text-font-primary h-[45px]
                        hover:bg-[#56f0f1] border border-slate-300
                        min-w-[200px]
                    "
                    onClick={onSubmitForm}
                >

                    <div
                        className="
                            text-font-primary text-[12px] md:text-sm  
                            xl:text-base font-semibold
                        "
                    >
                        {
                            !loading ?
                                <span>
                                    CONTINUE
                                </span> :
                                <span className="min-w-[30px]">
                                    <Line loading={loading} />
                                </span>
                        }
                    </div>
                </Button>
            </div>
        </>
    )
}

export default AddAddress